"use client";

import { ChevronDown } from "lucide-react";

export const ScrollHint = () => {
  const handleClick = () => {
    document
      .getElementById("catalogo")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="mb-2 flex justify-center">
      <button
        type="button"
        onClick={handleClick}
        aria-label="Descubre más productos"
        className="text-green-main font-inter flex flex-col items-center gap-1 py-3 text-sm font-medium"
      >
        Descubre más
        <ChevronDown className="h-6 w-6 animate-bounce" />
      </button>
    </div>
  );
};
